import React from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";
import { Modal, Button } from "react-bootstrap";

function ModalOtrosDocumentos(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [tituloDocumento, setTituloDocumento] = useState('');
    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});


    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);
    const LIMITE_CONTENIDO_DOCUMENTO = 200000;
    const LIMITE_TITULO_DOCUMENTO = 100;

    const longitudContenidoDocumento = () => String(contenido || '').length;

    const contenidoExcedeLimite = () => longitudContenidoDocumento() > LIMITE_CONTENIDO_DOCUMENTO;

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-otros-documentos', {
            ...config,
            headers: {
                ...config.headers,
                'X-Suppress-403-Modal': '1',
            },
        })
            .then(response => {
                setPlantillas(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                console.log(error);
                setPlantillas([]);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        //cargaritems();

    }, []);


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/otros-documentos', config2)
            .then(response => {
                console.log('Respuesta otros documentos:', response.data);
                const lista = Array.isArray(response.data) ? response.data : [];
                setHistorial(lista);
                try {
                    setConsolidado(construirHtmlConsolidadoDocumentos(lista));
                } catch (e) {
                    console.error('Error generando consolidado otros documentos:', e);
                    setConsolidado('');
                }
            })
            .catch(error => {
                console.log('Error cargando otros documentos:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
        if (errorlist.contenido) {
            setErrorlist((prev) => {
                const next = { ...prev };
                delete next.contenido;
                return next;
            });
        }
    }




    const contenidoDocumentoNoVacio = () => {
        if (contenido == null || String(contenido).trim() === '') return false;
        const t = String(contenido).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
        return t.length > 0;
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        // 🛡️ PREVENCIÓN DE DOBLE CLIC 🛡️
        if (deshabilitarBotonGuardar || loading) return;
        
        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        if (!fechaHora || !String(fechaHora).trim()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            alert('La fecha y hora son obligatorias.');
            return;
        }
        if (!tituloDocumento || !String(tituloDocumento).trim()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            alert('El título del documento es obligatorio.');
            return;
        }
        if (!contenidoDocumentoNoVacio()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            alert('El contenido del documento es obligatorio.');
            return;
        }
        if (contenidoExcedeLimite()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            setErrorlist({
                contenido: [`El contenido no puede superar ${LIMITE_CONTENIDO_DOCUMENTO} caracteres.`]
            });
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            titulo: tituloDocumento,
            contenido: contenido,
            hora_inicial: fechaHora
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        console.log('Enviando datos de otro documento:', data);

        axios.post('/otro-documento', data, config)
            .then(response => {
                console.log('Documento guardado exitosamente:', response.data);
                setLoading(false);
                setDeshabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito

                // 🆕 Mostrar modal de confirmación post-guardado
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false); // 🛡️ RE-ACTIVAR BOTÓN SI HAY ERROR
                console.log('Error guardando otro documento:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })

    }


    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const establecerFechaHoraActual = () => {
        setFechaHora(formatearFechaHoraParaInput(new Date()));
    };

    // 🆕 Función para generar encabezado personalizado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        // Función auxiliar para limpiar HTML y evitar saltos de línea innecesarios
        const limpiarHTML = (html) => {
            if (!html) return '';
            // Reemplazar <p> tags con divs para un control más preciso
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        // USAR TABLA EN LUGAR DE FLEXBOX PARA MEJOR COMPATIBILIDAD CON PDF
        // FONDO BLANCO Y SIN BORDES
        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <!-- Columna Izquierda (30%) -->
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <!-- Columna Centro (40%) -->
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <!-- Columna Derecha (30%) -->
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfDocumentoItem = (secciones, documento, { incluirPaciente = true } = {}) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const bannerTitulo = (documento.titulo && String(documento.titulo).trim())
            ? String(documento.titulo).trim().toUpperCase()
            : 'OTRO DOCUMENTO';

        const profTrat = documento.profesional_tratante_completo &&
            documento.profesional_tratante_completo !== 'No registrado'
            ? documento.profesional_tratante_completo
            : 'No registrado';

        const filasMeta = [];
        if (incluirPaciente) {
            filasMeta.push({ etiqueta: 'PACIENTE', valor: nombreCompleto });
            filasMeta.push({ etiqueta: 'DOCUMENTO', valor: documentoCompleto });
        }
        filasMeta.push({ etiqueta: 'FECHA Y HORA', valor: String(documento.fecha || '') });
        filasMeta.push({ etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat });

        const gris = [248, 249, 250];
        secciones.push({
            tipo: 'tabla-datos',
            datos: { filas: filasMeta },
            estilos: {
                bodyStyles: { fillColor: gris },
                alternateRowStyles: { fillColor: gris },
                columnStyles: {
                    0: { cellWidth: 52, fontStyle: 'bold', fillColor: gris },
                    1: { cellWidth: 'auto', fillColor: gris },
                },
            },
        });

        secciones.push({
            tipo: 'subtitulo',
            contenido: bannerTitulo,
            estilos: {
                alineacion: 'center',
                fontSize: 12,
                margenSuperiorMm: 4,
                espacioDespuesMm: 6,
            },
        });

        const cuerpoHtml = (documento.contenido && String(documento.contenido).trim())
            ? documento.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        secciones.push({
            tipo: 'texto',
            contenido: cuerpoHtml,
            estilos: { margenSuperiorMm: 1 },
        });

        const tieneProf = documento.profesional_tratante_completo &&
            documento.profesional_tratante_completo !== 'No registrado';
        if (tieneProf && documento.profesional && documento.firma_final) {
            const firmaMetadata = documento.texto_pie_firma_usuario
                ? {
                    tipo: 'profesional',
                    textoPieFirma: documento.texto_pie_firma_usuario
                  }
                : {
                    tipo: 'profesional',
                    nombre: documento.profesional || '',
                    registroMedico: documento.registro_medico || 'N/A',
                    codigoHabilitacion: documento.codigo_habilitacion || 'N/A'
                  };
            secciones.push({
                tipo: 'firma',
                imagenBase64: documento.firma_final,
                metadata: firmaMetadata,
                estilos: {
                    // Sin banda gris: solo separador + título + imagen (como Evolución)
                    estiloEvolucion: true,
                    separadorPrevia: true,
                    margenSuperiorMm: 4,
                },
            });
        }
    };

    const construirConfigPdfDocumentoNativo = (documento) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `otro-documento-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };

        rellenarSeccionesPdfDocumentoItem(config.secciones, documento, { incluirPaciente: true });
        return config;
    };

    const construirConfigPdfDocumentosConsolidadoNativo = () => {
        if (!historial || historial.length === 0) {
            return null;
        }
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `otros-documentos-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };

        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'OTROS DOCUMENTOS CONSOLIDADOS',
            estilos: {
                alineacion: 'center',
                fontSize: 13,
                margenSuperiorMm: 0,
                espacioDespuesMm: 8,
            },
        });

        historial.forEach((item, index) => {
            if (index > 0) {
                config.secciones.push({ tipo: 'salto-pagina' });
            }
            rellenarSeccionesPdfDocumentoItem(config.secciones, item, { incluirPaciente: true });
        });

        return config;
    };

    /** Cuerpo de un ítem (vista HTML / impresión). */
    const construirHtmlCuerpoDocumentoItem = (documento) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const bannerTitulo = (documento.titulo && String(documento.titulo).trim())
            ? String(documento.titulo).trim().toUpperCase()
            : 'OTRO DOCUMENTO';

        const profTrat = documento.profesional_tratante_completo &&
            documento.profesional_tratante_completo !== 'No registrado'
            ? documento.profesional_tratante_completo
            : 'No registrado';

        const celdaEtiqueta = 'background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;';
        const celdaValor = 'background-color: #f8f9fa; padding: 8px 12px; border: 1px solid #dee2e6;';

        const tablaUnificada = `
            <div style="margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="${celdaEtiqueta}">PACIENTE</td>
                            <td style="${celdaValor}">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DOCUMENTO</td>
                            <td style="${celdaValor}">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">FECHA Y HORA</td>
                            <td style="${celdaValor}">${documento.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">PROFESIONAL TRATANTE</td>
                            <td style="${celdaValor} font-weight: bold; color: #325e68;">${profTrat}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const tituloCentrado = `
            <div style="margin: 8px 0 14px; text-align: center; font-weight: bold; font-size: 15px; color: #212529; letter-spacing: 0.02em;">
                ${bannerTitulo}
            </div>`;

        const cuerpoHtml = (documento.contenido && String(documento.contenido).trim())
            ? documento.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueDocumento = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 13px;">
                    <style type="text/css">
                        .documento-preview-rich,
                        .documento-preview-rich * {
                            white-space: normal;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        }
                    </style>
                    <div class="documento-preview-rich">${cuerpoHtml}</div>
                </div>
            </div>`;

        const tieneProf = documento.profesional_tratante_completo &&
            documento.profesional_tratante_completo !== 'No registrado';
        let bloqueFirma = '';
        if (tieneProf && documento.profesional && documento.firma_final) {
            const pieFirmaHtml = documento.texto_pie_firma_usuario
                ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line;">${documento.texto_pie_firma_usuario}</div>`
                : `<div style="font-size: 13px; color: #6c757d; line-height: 1.45;">
                    <strong>${documento.profesional}</strong><br/>
                    RM: ${documento.registro_medico || 'N/A'} | Habilitación: ${documento.codigo_habilitacion || 'N/A'}
                  </div>`;

            // padding-left 12px = mismo que celdaEtiqueta (padding: 8px 12px) → alinea con PACIENTE, etc.
            bloqueFirma = `
                <div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 0; margin-bottom: 12px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del profesional
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieFirmaHtml}</div>
                        <div style="flex-shrink: 0;">
                            <img src="${documento.firma_final}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                        </div>
                    </div>
                </div>`;
        }

        return tablaUnificada + tituloCentrado + bloqueDocumento + bloqueFirma;
    };

    const construirHtmlVistaDocumentoNativa = (documento) => {
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';

        return encabezadoPrev +
            '<div class="vista-documento-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            construirHtmlCuerpoDocumentoItem(documento) +
            '</div>';
    };

    const construirHtmlConsolidadoDocumentos = (items) => {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const titulo = '<h1 style="text-align: center; margin-bottom: 16px; font-size: 1.25rem; color: #323a45;">OTROS DOCUMENTOS CONSOLIDADOS</h1>';
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;" />';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoDocumentoItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div class="consolidado-documentos-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            titulo +
            bloques +
            '</div>';
    };

    const verDocumento = (documento) => {
        console.log('Visualizando documento PDF:', documento);
        setTituloResumen((documento.titulo || 'Otro Documento') + ' - Vista Previa');
        setDocumentoSeleccionado(documento);
        setContenidoResumenIndividual(construirHtmlVistaDocumentoNativa(documento));
        setShowModalResumen(true);
    };

    const nuevoDocumento = () => {
        // Limpiar formulario para nuevo documento
        setDocumentoSeleccionado(null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setTituloDocumento('');
        setContenido('');

        if (document.getElementById('plantillasOtrosDocumentos')) {
            document.getElementById('plantillasOtrosDocumentos').value = "";
        }
    }

    const descargarPdfDocumento = async () => {
        if (!documentoSeleccionado) return;

        try {
            const config = construirConfigPdfDocumentoNativo(documentoSeleccionado);
            const pdf = await generarPdfConTextoNativo(config);
            const name = config.filename || 'otro-documento-' + (props.docPaciente || 'paciente') + '.pdf';
            pdf.save(name);
        } catch (err) {
            console.error('PDF nativo otro documento (descarga):', err);
            alert('No se pudo generar el PDF. Intente de nuevo.');
        }
    };

    const descargarPdfConsolidado = async () => {
        const config = construirConfigPdfDocumentosConsolidadoNativo();
        if (!config) {
            alert('No hay documentos en el historial para exportar.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename || 'otros-documentos-consolidado.pdf');
        } catch (err) {
            console.error('PDF nativo consolidado otros documentos:', err);
            alert('No se pudo generar el PDF consolidado. Intente de nuevo.');
        }
    };

    const imprimirPdfConsolidado = async () => {
        const config = construirConfigPdfDocumentosConsolidadoNativo();
        if (!config) {
            alert('No hay documentos en el historial para imprimir.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                window.open(url, '_blank');
            }
        } catch (err) {
            console.error('Imprimir PDF nativo consolidado otros documentos:', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    const imprimirDocumento = async () => {
        if (!documentoSeleccionado) {
            alert('No hay documento seleccionado para imprimir');
            return;
        }

        try {
            const config = construirConfigPdfDocumentoNativo(documentoSeleccionado);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Descargue el PDF e imprímalo desde su visor.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        } catch (err) {
            console.error('PDF nativo otro documento (imprimir):', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    // 🆕 Funciones del Modal de Confirmación
    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        nuevoDocumento();
        // No guardarCambios(msg): en AtenderPaciente2 solo dispara un toast duplicado del mismo mensaje.
        // El historial ya se actualizó con cargaritems() al guardar.
    };

    // 🆕 Función para cerrar el modal de vista previa y limpiar recursos
    const cerrarModalResumen = () => {
        // Limpiar blob URL si existe
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.src && iframe.src.startsWith('blob:')) {
            URL.revokeObjectURL(iframe.src);
        }
        setShowModalResumen(false);
    };

    /** Vista previa en iframe: mismo PDF nativo que descarga / imprime (texto paginado, sin html2canvas). */
    const verResumen = async (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setDocumentoSeleccionado(resumenIndividual);

        try {
            const config = construirConfigPdfDocumentoNativo(resumenIndividual);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const iframeHTML = `<iframe src="${url}" style="width: 100%; height: 600px; border: none;"></iframe>`;
            setContenidoResumenIndividual(iframeHTML);
            setShowModalResumen(true);
        } catch (err) {
            console.error('Vista previa PDF nativo otro documento:', err);
            alert('No se pudo generar la vista previa en PDF.');
        }
    };


    useEffect(() => {
        if (!props.cargarHistorial) return;

        cargaritems();

        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
            setDocumentoSeleccionado(null);
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `otros-documentos.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 4, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let documentosCompleta = "<img src='" + logoImg + "' className='app-logo-pdf' /><h1 className='ttl-pdf'>OTROS DOCUMENTOS</h1>" + anamnesis + "<div className='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(documentosCompleta, opt);
    }


    if (loggedIn) {
        return (


            <>
                <style>{`
                    /* CKEditor usa <p> por Enter; reducimos márgenes para evitar "doble salto" visual */
                    .documento-editor .ck-editor__editable p {
                        margin: 0 0 0.25rem 0 !important;
                    }
                    .documento-editor .ck-editor__editable p:last-child {
                        margin-bottom: 0 !important;
                    }
                `}</style>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza el documento</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7">
                                                        <div className="form-group">
                                                            <label>Fecha y Hora <span className="text-danger">*</span></label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" required value={fechaHora} onChange={(e) => setFechaHora(e.target.value)} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-dark" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Seleccione la plantilla o digite su contenido <span className="text-danger">*</span></label>
                                                    <select
                                                        name="plantillasOtrosDocumentos"
                                                        className="form-control"
                                                        id="plantillasOtrosDocumentos"
                                                        onChange={(e) => {
                                                            const plantilla = plantillas.find(p => String(p.id) === String(e.target.value));
                                                            if (plantilla) {
                                                                setTituloDocumento(plantilla.titulo || '');
                                                                setContenido(plantilla.contenido || '');
                                                            }
                                                        }}
                                                    >
                                                        <option value=""></option>
                                                        {(Array.isArray(plantillas) ? plantillas : []).map((plantilla) =>
                                                            <option key={plantilla.id} value={plantilla.id}>{plantilla.titulo}</option>
                                                        )}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="tituloDocumento">Título del documento <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="tituloDocumento"
                                                        className="form-control"
                                                        id="tituloDocumento"
                                                        maxLength={LIMITE_TITULO_DOCUMENTO}
                                                        value={tituloDocumento}
                                                        onChange={(e) => setTituloDocumento(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div className="form-group documento-editor" style={{ marginBottom: 0 }}>
                                                    <label>Contenido</label>
                                                    <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                    <small className={`form-text ${contenidoExcedeLimite() ? 'text-danger font-weight-bold' : 'text-muted'}`}>
                                                        {longitudContenidoDocumento()} / {LIMITE_CONTENIDO_DOCUMENTO} caracteres
                                                    </small>
                                                    {errorlist.contenido && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.contenido}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    {firmaimg && (
                                                        <div className="col-md-4">
                                                            <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                                <label htmlFor="nombreProfesional">Firma</label>
                                                                <br></br>
                                                                <img src={firmaimg} className="firma-profesional-hc" />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={firmaimg ? "col-md-8" : "col-md-12"}>
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Pie de Firma</label>
                                                            <br></br>
                                                            {textoPieFirma ? (
                                                                <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                    {textoPieFirma}
                                                                </div>
                                                            ) : (
                                                                <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                    {nombreProfesional}<br/>
                                                                    <small>RM: {registroMedico || 'N/A'} | Hab: {codigoHabilitacion || 'N/A'}</small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar || contenidoExcedeLimite()}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Otros Documentos</b>

                                    {
                                        (Array.isArray(historial) ? historial : []).map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verDocumento(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}{item.titulo ? ` — ${item.titulo}` : ''}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-dark btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>

                            </div>

                        </div>

                    </div>
                </section>

                <Modal show={showModalResumen} onHide={cerrarModalResumen} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" size="sm" onClick={imprimirDocumento}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="dark" size="sm" onClick={descargarPdfDocumento}>
                            <i className="fas fa-file-pdf mr-1"></i> Guardar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={cerrarModalResumen}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen Otros Documentos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" size="sm" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="dark" size="sm" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* 🆕 Modal de Confirmación Post-Guardado */}
                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-alt mr-1"></i> Documento Guardado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            El documento ha sido guardado exitosamente. Puede abrirlo desde el historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalOtrosDocumentos;